// Module
var code = "<a data-bind=\"enableAttr: _isEnabled,\r\n\t\t\t\ttooltip:{content: _labels.ADD_TO_FAVORITES},\r\n\t\t\t\tclick: Click,\r\n\t\t\t\tstyle: _style,\r\n\t\t\t\tcss: {choosen:_isFavorite, disabled: !_isEnabled()}\" tabindex=\"-1\" class=\"subFormControl toggle-favourites transition\"> <i class=\"fa fa-star transition\"></i> </a>";
// Exports
export default code;